/**
 * Get the image path for an item based on its type.
 *
 * Packs use a different directory structure:
 * - Pack items: /packs/pack-{item_id}.png
 * - Other items: /items/item-{item_id}.png
 *
 * @param {Object} item - The item object with item_type and item_id properties
 * @returns {string} The image path for the item
 */
export function getItemImagePath(item) {
  if (!item || !item.item_id) {
    return '/items/placeholder.png'
  }

  if (item.item_type === 'pack') {
    return `/packs/pack-${item.item_id}.png`
  }

  // Blueprints should show the image of the item they unlock
  if (item.item_type === 'blueprint' && item.unlocks_item_id) {
    return `/items/item-${item.unlocks_item_id}.png`
  }

  return `/items/item-${item.item_id}.png`
}
